<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_v"></a><a id="dedication"></a>To the three bestideas<br/>I ever had—<br/>My wife Nancy,<br/>and my sons,<br/>Mark and Tim</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?3afd3ef5